module.exports = __webpack_public_path__ + "static/media/DSC_0380.8b4c4f5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0380.jpg
// module id = 580
// module chunks = 0